import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import store from "../../store";
import { refreshTokenAPI } from "../../API/endpoints/auth";
import { sliceActions as authActions } from "../../store/auth-slice";

const PersistLogin = () => {
  const [isLoading, setIsLoading] = useState(true);
  const refreshToken = localStorage.getItem("refresh");
  const accessToken = useSelector((state) => state.auth.accessToken);

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const currentPath = location.pathname;

  useEffect(() => {
    let isMounted = true;

    const verifyRefreshToken = async () => {
      try {
        const response = await refreshTokenAPI(refreshToken);
        store.dispatch(authActions.setAccessToken(response?.token));
        if (response && currentPath.startsWith("/auth")) {
          navigate(from, { replace: true });
        }
      } catch (err) {
        console.error(err);
        navigate("/auth/login", { state: { from: location }, replace: true });
      } finally {
        isMounted && setIsLoading(false);
      }
      return () => (isMounted = false);
    };

    !accessToken && refreshToken ? verifyRefreshToken() : setIsLoading(false);

    return () => (isMounted = false);
  }, [accessToken, refreshToken, navigate, from, location, currentPath]);

  return <>{isLoading ? <p>Loading...</p> : <Outlet />}</>;
};

export default PersistLogin;
